export default __webpack_public_path__ + "static/media/Word_icon.85654619.svg";